export function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("This photo format can't be opened in this browser. Please use a JPG or PNG."));
    img.src = src;
  });
}

const toBlob = (canvas) => new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.92));

export async function cropToFile(src, area, width = 1000, height = 1250) {
  const img = await loadImage(src);
  const c = document.createElement("canvas");
  c.width = width;
  c.height = height;
  const ctx = c.getContext("2d");
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(img, area.x, area.y, area.width, area.height, 0, 0, width, height);
  return new File([await toBlob(c)], "board-photo.jpg", { type: "image/jpeg" });
}

export async function optimizeOriginal(src, max = 2400) {
  const img = await loadImage(src);
  const s = Math.min(1, max / Math.max(img.width, img.height));
  const c = document.createElement("canvas");
  c.width = Math.round(img.width * s);
  c.height = Math.round(img.height * s);
  const ctx = c.getContext("2d");
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(img, 0, 0, c.width, c.height);
  return new File([await toBlob(c)], "board-original.jpg", { type: "image/jpeg" });
}
